document.addEventListener('DOMContentLoaded', function () {
  const sublist = document.querySelector('.product__media-sublist')
  const mainList = document.querySelector('.js-media-list')
  const thumbnails = document.querySelectorAll('.product__media-subitem')
  const upThumbnail = document.querySelector('.product__thumbnail.up')
  const downThumbnail = document.querySelector('.product__thumbnail.down')
  const sublistContainer = document.querySelector('.product__media-sublist-container')
  let isScrolling

  if (!sublist || !thumbnails.length || !sublistContainer) return

  function assertTabindex() {
    sublist.removeAttribute('tabindex')
    const visible = getVisibleThumbnails()
    const activeThumb =
      visible.find((t) => t.getAttribute('aria-selected') === 'true') || visible[0]
    visible.forEach((t) => {
      t.setAttribute('tabindex', t === activeThumb ? '0' : '-1')
    })
  }

  function getVisibleThumbnails() {
    return Array.from(thumbnails).filter(
      (thumb) => thumb.style.display !== 'none' && !thumb.classList.contains('is-hidden')
    )
  }

  function getActiveThumbnailIndex() {
    const visible = getVisibleThumbnails()
    return visible.findIndex(
      (thumb) => thumb.getAttribute('aria-selected') === 'true' || thumb.getAttribute('tabindex') === '0'
    )
  }

  function navigateMainSlider(thumbIndex) {
    const mainSwiper = mainList?.swiper
    if (mainSwiper) {
      mainSwiper.slideTo(thumbIndex, 500)
    }
  }

  function selectThumbnail(thumb) {
    const visible = getVisibleThumbnails()
    const thumbIndex = visible.indexOf(thumb)

    visible.forEach((t) => {
      t.setAttribute('aria-selected', 'false')
      t.setAttribute('tabindex', '-1')
    })
    thumb.setAttribute('aria-selected', 'true')
    thumb.setAttribute('tabindex', '0')
    thumb.focus()

    navigateMainSlider(thumbIndex)
  }

  function moveFocus(direction) {
    const visible = getVisibleThumbnails()
    if (!visible.length) return

    const currentIndex = getActiveThumbnailIndex()
    let nextIndex

    if (direction === 'next') {
      nextIndex = currentIndex + 1 >= visible.length ? 0 : currentIndex + 1
    } else {
      nextIndex = currentIndex - 1 < 0 ? visible.length - 1 : currentIndex - 1
    }

    selectThumbnail(visible[nextIndex])
  }

  function moveToFirst() {
    const visible = getVisibleThumbnails()
    if (visible.length) selectThumbnail(visible[0])
  }

  function moveToLast() {
    const visible = getVisibleThumbnails()
    if (visible.length) selectThumbnail(visible[visible.length - 1])
  }

  sublist.addEventListener('keydown', function (e) {
    const isVertical = sublist.getAttribute('aria-orientation') === 'vertical'
    let handled = false

    switch (e.key) {
      case 'ArrowUp':
        if (isVertical) {
          moveFocus('prev')
          handled = true
        }
        break
      case 'ArrowDown':
        if (isVertical) {
          moveFocus('next')
          handled = true
        }
        break
      case 'ArrowLeft':
        moveFocus('prev')
        handled = true
        break
      case 'ArrowRight':
        moveFocus('next')
        handled = true
        break
      case 'Home':
        moveToFirst()
        handled = true
        break
      case 'End':
        moveToLast()
        handled = true
        break
      case 'Enter':
      case ' ': {
        const focused = document.activeElement
        if (focused && focused.classList.contains('product__media-subitem')) {
          selectThumbnail(focused)
          handled = true
        }
        break
      }
    }

    if (handled) {
      e.preventDefault()
      e.stopPropagation()
    }
  })

  function syncAriaToActiveSlide() {
    const visible = getVisibleThumbnails()
    const ms = mainList?.swiper
    if (!ms) return

    const activeIndex = ms.activeIndex
    visible.forEach((t, i) => {
      const isActive = i === activeIndex
      t.setAttribute('aria-selected', isActive ? 'true' : 'false')
      t.setAttribute('tabindex', isActive ? '0' : '-1')
    })
    sublist.removeAttribute('tabindex')
  }

  const mainSwiper = mainList?.swiper
  if (mainSwiper) {
    mainSwiper.on('slideChangeTransitionEnd', syncAriaToActiveSlide)
  }

  assertTabindex()

  const thumbSwiper = sublist?.swiper

  function updateArrowVisibility() {
    if (thumbSwiper) {
      const isAtTop = thumbSwiper.isBeginning
      const isAtBottom = thumbSwiper.isEnd

      upThumbnail.classList.toggle('visible', !isAtTop && !!upThumbnail)
      downThumbnail.classList.toggle('visible', !isAtBottom && !!downThumbnail)
    } else {
      const isAtTop = sublistContainer.scrollTop <= 0
      const isAtBottom =
        Math.abs(sublistContainer.scrollTop + sublistContainer.clientHeight - sublistContainer.scrollHeight) <= 2

      upThumbnail.classList.toggle('visible', !isAtTop && !!upThumbnail)
      downThumbnail.classList.toggle('visible', !isAtBottom && !!downThumbnail)
    }

    if (upThumbnail.classList.contains('visible')) {
      sublistContainer.style.bottom = '16px'
      sublistContainer.style.top = 'unset'
    } else {
      sublistContainer.style.bottom = '0'
    }
    if (downThumbnail.classList.contains('visible')) {
      sublistContainer.style.top = '0'
    } else {
      sublistContainer.style.top = 'unset'
    }

    upThumbnail.disabled = !upThumbnail.classList.contains('visible')
    downThumbnail.disabled = !downThumbnail.classList.contains('visible')
  }

  function showThumbnails() {
    upThumbnail.classList.add('visible')
    downThumbnail.classList.add('visible')
    thumbnails.forEach((thumb) => thumb.classList.add('visible'))
    clearTimeout(isScrolling)
  }

  function hideThumbnails() {
    clearTimeout(isScrolling)
    isScrolling = setTimeout(function () {
      thumbnails.forEach((thumb) => thumb.classList.remove('visible'))
      updateArrowVisibility()
    }, 300)
  }

  if (thumbSwiper) {
    thumbSwiper.on('slideChangeTransitionStart', function () {
      showThumbnails()
      updateArrowVisibility()
    })
    thumbSwiper.on('slideChangeTransitionEnd', function () {
      hideThumbnails()
    })
    updateArrowVisibility()
  } else {
    sublistContainer.addEventListener('scroll', function () {
      showThumbnails()
      updateArrowVisibility()
      hideThumbnails()
    })
    updateArrowVisibility()
  }

  upThumbnail.addEventListener('click', function () {
    if (thumbSwiper) {
      thumbSwiper.slideTo(0, 300)
    } else {
      sublistContainer.scrollTo({ top: 0, behavior: 'smooth' })
    }
  })

  downThumbnail.addEventListener('click', function () {
    if (thumbSwiper) {
      thumbSwiper.slideNext(300)
    } else {
      const thumbnailHeight = thumbnails[0]?.offsetHeight || 100
      sublistContainer.scrollTo({ top: sublistContainer.scrollTop + thumbnailHeight, behavior: 'smooth' })
    }
  })
})
